export default __webpack_public_path__ + "static/ak-cached/24h/media/amexcard_cvv.7e828d7f.png";